import { theme } from '../Provider'
import * as baseStyles from '../base/styles'

export const useModalStyles = () => ({
    ...baseStyles.useModalStyles(theme),
})

export const useTransactionsStyles = () => ({
    ...baseStyles.useTransactionsStyles(theme),
})

export const useSignStyles = () => ({
    ...baseStyles.useSignStyles(theme),
})

export const useSettingsPageStyles = () => ({
    ...baseStyles.useSettingsPageStyles(theme),
})

export const useCardToInformUserStyles = () => ({
    ...baseStyles.useCardToInformUserStyles(theme),
})

export const useSideBarNavigationStyles = () => ({
    ...baseStyles.useSideBarNavigationStyles(theme),
})

export const useServicePlanStyles = () => ({
    ...baseStyles.useServicePlanStyles(theme),
})

export const useHeaderStyles = () => ({
    ...baseStyles.useHeaderStyles(theme),
})

export const useAlertComponentsStyles = () => ({
    ...baseStyles.useAlertComponentsStyles(theme),
})

export const useLegalStyles = () => ({
    ...baseStyles.useLegalStyles(theme),
})

export const useTableStyles = () => ({
    ...baseStyles.useTableStyles(theme),
})

export const useAcquiringStyles = () => ({
    ...baseStyles.useAcquiringStyles(theme),
})

export const use2FAAuthenticatorStyles = () => ({
    ...baseStyles.use2FAAuthenticatorStyles(theme),
})

export const useSelectInputs = () => ({
    ...baseStyles.useSelectInputs(theme),
})

export const useFeeSummaryStyles = () => ({
    ...baseStyles.useFeeSummaryStyles(theme),
})

export const cardFormButtonBoxStyles = () => ({
    ...baseStyles.cardFormButtonBoxStyles(theme),
})

export const useWizardStyles = () => ({
    ...baseStyles.useWizardStyles(theme),
})

export const useReferralsStyles = () => ({
    ...baseStyles.useReferralsStyles(theme),
})
